import {Module} from 'vuex'

export const accountStore: Module<any, any> = {
  state: {
    logon: false,
    userIdentity: null,
    ribbonOnProfiles: '',
    activeProfiles: '',
    authorizedIhm: false,
    authorizedPtddt: false,
    loggingIhm: false,
    loggingPtddt: false
  },
  getters: {
    logon: (state) => state.logon,
    account: (state) => state.userIdentity,
    activeProfiles: (state) => state.activeProfiles,
    ribbonOnProfiles: (state) => state.ribbonOnProfiles,
    isAuthorizedIhm: (state) => state.authorizedIhm,
    isAuthorizedPtddt: (state) => state.authorizedPtddt,
    isAuthenticated: (state) => state.authorizedIhm && state.authorizedPtddt,
    isLoggingIhm: (state) => state.loggingIhm,
    isLoggingPtddt: (state) => state.loggingPtddt,
    mustLogOntoIhm: (state, getters) => getters.isAuthorizedPtddt && !getters.isAuthorizedIhm && !getters.isLoggingIhm,
    mustLogOntoPtddt: (state, getters) => getters.isAuthorizedIhm && !getters.isAuthorizedPtddt && !getters.isLoggingPtddt
  },
  mutations: {
    authenticate(state) {
      state.logon = true
    },
    authenticated(state, identity) {
      state.userIdentity = identity
      state.logon = false
    },
    loggingIhm(state) {
      state.loggingIhm = true
    },
    loggingPtddt(state) {
      state.loggingPtddt = true
    },
    logout(state) {
      state.userIdentity = null
      state.logon = false
      state.authorizedIhm = false
      state.authorizedPtddt = false
      state.loggingIhm = false
      state.loggingPtddt = false
    },
    authorizedIhm(state) {
      state.authorizedIhm = true
      state.loggingIhm = false
    },
    authorizedPtddt(state) {
      state.authorizedPtddt = true
      state.loggingPtddt = false
    },
    setActiveProfiles(state, profile) {
      state.activeProfiles = profile
    },
    setRibbonOnProfiles(state, ribbon) {
      state.ribbonOnProfiles = ribbon
    }
  }
}
